import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Leaf, Instagram } from "lucide-react";

const LOGO_WORDMARK = "/bloomers-wordmark.png";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-24 border-t border-[#21C078]/15 bg-[#F0EBE1]/60">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <img src={LOGO_WORDMARK} alt="Bloomers" className="h-14 w-auto mb-4" />
          <div className="text-xs font-bold tracking-widest text-[#21C078] uppercase mb-3">
            Bloomers<sup className="text-[9px] ml-0.5">™</sup> · Inspired Plantscapes
          </div>
          <p className="text-[#1C1C1C]/70 max-w-md leading-relaxed">
            Local woman-owned plantscape design & installation service for the greater Lake Norman region.
            Beautifying yards one thoughtful garden at a time.
          </p>
          <div className="mt-6 flex items-center gap-3">
            <div className="flex items-center gap-2 text-[#21C078] font-bold">
              <Leaf className="w-4 h-4" /> BLOOMLKN · North Carolina
            </div>
            <a
              href="https://www.instagram.com/bloomers_lkn"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              aria-label="Bloomers on Instagram"
              className="ml-auto md:ml-4 w-10 h-10 grid place-items-center rounded-full bg-gradient-to-br from-[#C12135] via-[#C0AD21] to-[#219DC0] text-white hover:scale-110 transition-transform"
            >
              <Instagram className="w-5 h-5" />
            </a>
          </div>
        </div>

        <div>
          <div className="pill-tag bg-[#21C078]/10 text-[#21C078] mb-4">Explore</div>
          <ul className="space-y-2 text-[#1C1C1C]/80">
            <li><Link to="/" className="hover:text-[#21C078]">Home</Link></li>
            <li><Link to="/services" className="hover:text-[#21C078]">Services</Link></li>
            <li><Link to="/gallery" className="hover:text-[#21C078]">Gallery</Link></li>
            <li><Link to="/contact" className="hover:text-[#21C078]">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="pill-tag bg-[#219DC0]/10 text-[#219DC0] mb-4">Reach us</div>
          <ul className="space-y-3 text-[#1C1C1C]/80 text-sm">
            <li className="flex items-start gap-2">
              <Mail className="w-4 h-4 mt-1 text-[#219DC0]" />
              <a href="mailto:Linda@BloomersLKN.com" className="hover:text-[#21C078] break-all">Linda@BloomersLKN.com</a>
            </li>
            <li className="flex items-start gap-2">
              <Phone className="w-4 h-4 mt-1 text-[#219DC0]" />
              <span>(704) 880-8969</span>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-1 text-[#219DC0]" />
              <span>Serving the Greater Lake Norman Region</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#21C078]/10 py-6 text-center text-sm text-[#1C1C1C]/60">
        © {new Date().getFullYear()} Bloomers<sup className="text-[9px] ml-0.5">™</sup> · Inspired Plantscapes
      </div>
    </footer>
  );
}
